import { Badge } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export const ConfirmedUnchangedBadge = ({ confirmedUnchanged }: { confirmedUnchanged?: boolean }) => {
  const { t } = useTranslation();
  if (!confirmedUnchanged) return null;
  return (
    <Badge colorScheme="gray" title={t("The supplier confirmed its tender unchanged in the round") ?? undefined}>
      {t("Confirmed standing bid")}
    </Badge>
  );
};
